import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { TaskCheck } from '@quizdb/common';

/** Props for `TaskCheckCard`. */
export interface TaskCheckCardProps {
  check: TaskCheck;
}

/**
 * What generation's check found for a draft (QZ-D60). Presentational: it takes the check
 * as a prop and runs no query of its own.
 */
export const TaskCheckCard = ({ check }: TaskCheckCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="qz-card">
      <div className="qz-card-header">
        <h3>{t('task.check.heading')}</h3>
      </div>
      <div className="qz-card-body qz-stack">
        <span className={`qz-status${check.outcome === 'passed' ? ' is-approved' : ' is-warning'}`}>
          {t(check.outcome === 'passed' ? 'task.check.passed' : 'task.check.revised')}
        </span>
        {check.note && (
          <dl className="qz-kv mb-0">
            <dt>{t('task.check.note')}</dt>
            <dd>{check.note}</dd>
          </dl>
        )}
        {check.similarTaskIds && (
          <div>
            <div className="qz-small qz-muted">{t('task.check.similar')}</div>
            <div className="d-flex flex-wrap gap-2">
              {check.similarTaskIds.map((id) => (
                // `target="_blank"` (QZ-D60): opening a similar task must not navigate away from
                // this draft, which may hold unsaved edits.
                <Link
                  key={id}
                  to={`/tasks/${id}`}
                  target="_blank"
                  rel="noreferrer"
                  className="qz-mono qz-small"
                >
                  {id.slice(0, 8)}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskCheckCard;
